import { useAppSelector } from "../../store/hooks/hooks";
import { getSecondWellIsOpen } from "../../store/slices/appSlice";
import Result from "../../components/common/Result";
import { t } from "i18next";
import i18n from "../../i18n/i18n";
import { Trans } from "react-i18next";


const EMPTY_RESULTS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

export const ResultsSection = () => {
	const calculator = useAppSelector(state => state.iprCalculator);
	const results1P = calculator?.well1?.results?.p ?? EMPTY_RESULTS;
	const results1Q = calculator?.well1?.results?.q ?? EMPTY_RESULTS;

	const results2P = calculator?.well2?.results?.p ?? EMPTY_RESULTS;
	const results2Q = calculator?.well2?.results?.q ?? EMPTY_RESULTS;

	const secondWell = useAppSelector(getSecondWellIsOpen);

	return (
		<fieldset className="ipr__result-block round-corner-container">
			<legend>{t("ipr:results_title")}</legend>
			<div className="ipr__well1__results">
				<div className="ipr__well1__results_title"><span>{t(`ipr:well1_title`)}</span></div>
				<div className="ipr__column_names">
					<div>
						<span>P </span>
						<span className="unit-font-size">
							<Trans
								ns={'ipr'}
								key={i18n.language}
								i18nKey={t(`common:measurement_units.pressure.bar`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>
						</span>
					</div>
					<div>
						<span>Q </span>
						<span className="unit-font-size">
							<Trans
								ns={'ipr'}
								key={i18n.language}
								i18nKey={t(`common:measurement_units.q.thousand_m3_day`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>
						</span>
					</div>
				</div>
				{results1P.map((result, i) => {
					return (<div className="ipr__result_row result-row" key={`ipr-well1-row-${i}`}>
						<Result
							className="ipr__result-value-p"
							id={`ipr-well1-p-${i}`}
							label={<></>}
							value={result.toString()}
						/>
						<Result
							className="ipr__result-value-q"
							id={`ipr-well1-q-${i}`}
							label={<></>}
							value={results1Q[i].toString()}
						/>
					</div>
					);
				})}
			</div>
			{secondWell &&
				<div className="ipr__well2__results">
					<div className="ipr__well2__results_title"><span>{t(`ipr:well2_title`)}</span></div>
					<div className="ipr__column_names">
						<div>
							<span>P </span>
							<span className="unit-font-size">
								<Trans
									ns={'ipr'}
									key={i18n.language}
									i18nKey={t(`common:measurement_units.pressure.bar`)}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							</span>
						</div>
						<div>
							<span>Q </span>
							<span className="unit-font-size">
								<Trans
									ns={'ipr'}
									key={i18n.language}
									i18nKey={t(`common:measurement_units.q.thousand_m3_day`)}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							</span>
						</div>
					</div>
					{results2P?.map((result, i) => {
						return (<div className="ipr__result_row result-row" key={`ipr-well2-row-${i}`}>
							<Result
								id={`ipr-well2-p-${i}`}
								label={<></>}
								value={result.toString()}
							/>
							<Result
								id={`ipr-well2-q-${i}`}
								label={<></>}
								value={results2Q[i].toString()}
							/>
						</div>);
					})}
				</div>
			}
		</fieldset>
	);
}